exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#live-header {\n  margin-bottom: 24px; }\n\n.close-recon {\n  position: absolute;\n  bottom: 0; }\n\n.closer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 30px; }\n  .closer .spinner {\n    margin-left: 24px; }\n\n.close-issues {\n  text-align: center;\n  display: inline; }\n  .close-issues p {\n    margin: 0;\n    color: #a32100; }\n\n.loading {\n  background-color: #ddd !important;\n  border-color: #ccc !important; }\n\n.stat-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .stat-text span {\n    margin-left: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/live-header/live-header.component.scss
// module id = ../../../../../src/app/views/daily-recon/live-header/live-header.component.scss
// module chunks = main